const date = '2026年9月24日'

const person = (name, position) => ({
  name,
  position: position ? [position] : []
})

const scheduleItem = (title, hostName = '', hostPosition = '', people = [], tableTalk = false) => ({
  date,
  title,
  type: '',
  host: person(hostName, hostPosition),
  tableTalk,
  people
})

const group = ({
  name,
  theme,
  time,
  location,
  zdOrganizer = [],
  organizer = [],
  undertaker = [],
  coOrganizer = [],
  schedule
}) => ({
  noSign: true,
  name,
  theme,
  desc: '',
  time,
  location,
  host: {
    name: '',
    position: []
  },
  zdOrganizer,
  organizer,
  undertaker,
  coOrganizer,
  zcOrganizer: [],
  users: [],
  contact: {
    name: '',
    phone: ''
  },
  schedule
})

const groupList = {
  // 开幕式
  'a5a4243c40d74147b006191889bd039b': group({
    name: '开幕式|岳麓论坛',
    theme: '智汇潇湘 赋能未来',
    time: '2026年9月24日（星期四）9:30-11:30',
    location: '世界计算·长沙智谷“云脑”',
    schedule: [
      scheduleItem('开幕式'),
      scheduleItem('时间：2026年9月24日（星期四）9:30-11:30'),
      scheduleItem('地点：世界计算·长沙智谷“云脑”'),
      scheduleItem('主题：智汇潇湘 赋能未来'),
      scheduleItem('主持：王道席', '王道席', '湖南省委常委、省政府常务副省长'),
      scheduleItem('观看2026岳麓大会宣传片'),
      scheduleItem('湖南省政府副省长、长沙市委书记陈竞致辞'),
      scheduleItem('湖南省委书记沈晓明致辞并宣布开幕'),
      scheduleItem('以下环节由湖南广播电视台主持人万欣主持', '万欣', '湖南广播电视台主持人'),
      scheduleItem('主旨演讲', '', '', [
        person('韩歆毅', '蚂蚁科技集团股份有限公司首席执行官'),
        person('陈 立', '宇树科技股份有限公司联合创始人、首席运营官'),
        person('郭彦东', '智平方（深圳）科技有限公司创始人、董事长、总经理'),
        person('熊友军', '国家地方共建具身智能机器人创新中心（北京人形机器人创新中心）总经理、CEO'),
        person('曾 光', '中联重科中科云谷科技有限公司总经理'),
        person('邓文平', '湖南视比特机器人有限公司董事长、首席执行官')
      ]),
      scheduleItem('未来产业基金发布暨落地湖南湘江新区签约')
    ]
  }),

  // AI+青年创业
  'b67a34cc52ad4429b1111c727e315436': group({
    name: 'AI+青年创业',
    theme: 'AI+青年创业',
    time: '2026年9月24日14:30-18:00',
    location: '世界计算·长沙智谷“云脑”',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['新湘青年'],
    coOrganizer: ['清科集团', '湖南麓山科技投资有限公司'],
    schedule: [
      scheduleItem('14:30-14:40 湖南省支持大学生创业工作推介'),
      scheduleItem('14:40-15:05 “AI+青年创业”仪式环节', '', '', [
        person('', '1.新湘会“双千行动”签约及创业导师授聘仪式'),
        person('', '2.新湘青年天使投资人“星光计划”启动仪式'),
        person('', '3.“新湘青年共创汇”成立仪式')
      ]),
      scheduleItem('15:05-15:35 主题演讲：《场景、链条与后浪：以产业资本视角拥抱青年创业者》', '章 锟', '上海孚腾私募基金管理有限公司管理合伙人'),
      scheduleItem('15:35-16:05 主题演讲：《一位AI创业者的实战方法论》', '段 威', '广州汇量网络科技股份有限公司创始人'),
      scheduleItem('16:05-16:30 主题演讲：《青年创业说：AI时代如何把想法做成生意》', '农荣斐', '湖南形态起源科技有限公司董事长兼CEO'),
      scheduleItem('16:30-16:55 主题演讲：《从连接到进化：智能体重塑OPC创业范式》', '胡 伟', '知识流动（杭州）智能科技有限公司CEO'),
      scheduleItem('16:55-18:00 圆桌论坛：《AI时代青年创业的机会与实践》', '王兴华', '51.com、2345.com联合创始人，AI顾问、技术专家', [
        person('陈维嘉', '长沙可滋泉生物科技有限公司CEO'),
        person('谌秀峰', '上海凡酷文化传媒有限公司总裁'),
        person('唐小波', '上海创蓝云智信息股份有限公司董事长'),
        person('周 星', '长沙草儿绽放科技有限公司CEO'),
        person('张 斌', '湖南元亨网络科技有限公司创始人')
      ], true)
    ]
  }),

  // AI+OpenCL异构计算
  'e920ef38302346d7b19fb627c1d0afa2': group({
    name: 'AI+OpenCL异构计算',
    theme: 'AI+OpenCL异构计算',
    time: '2026年9月24日14:00-17:30',
    location: '长沙步步高福朋喜来登酒店五楼多功能2、3厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: [
      '湖南集成电路产业技术创新战略联盟',
      '湖南省半导体行业协会',
      '国家图形处理芯片与智能计算系统技术创新中心'
    ],
    coOrganizer: [
      '长沙景嘉微电子股份有限公司',
      '长沙全赢半导体有限公司',
      '长沙优智创芯科技有限公司'
    ],
    schedule: [
      scheduleItem('主持人：孔 荔', '孔 荔', '中国科纳斯顾问委员会（CKAP）秘书、长沙全赢半导体有限公司副总经理'),
      scheduleItem('14:10-14:20 领导讲话'),
      scheduleItem('14:20-14:35 主题演讲：《OpenCL标准工作小组运作和全球业界生态》', '傅世雄', '科纳斯标准联盟（Khronos Group）亚太区域副总裁、中国科纳斯顾问委员会（CKAP）顾问'),
      scheduleItem('14:35-14:50 主题演讲：《乘影开源GPGPU与OpenCL软件栈》', '何 虎', '上海清华国际创新中心副主任、清华大学集成电路学院副教授、中国科纳斯顾问委员会（CKAP）召集人、长沙全赢半导体有限公司首席科学家'),
      scheduleItem('14:50-15:05 主题演讲：《迎接开放算力新时代：算能RISC-V与TPU产业应用实践》', '康晓啸', '算能科技股份有限公司产品线总经理'),
      scheduleItem('15:05-15:20 主题演讲：《从模型到设备：Qwen3.8-27B端侧智能在Lisuan GPU上的OpenCL落地实践》', '夏志迁', '砺算科技有限公司高级工程师'),
      scheduleItem('15:20-15:35 主题演讲：《金融量化与OpenCL算子库开发》', '林建武', '清华大学深圳国际研究生院创新管理学院教授、量化投资研究中心主任'),
      scheduleItem('15:35-15:50 主题演讲：《基于子空间理论和大语言模型的新一代集成电路设计自动化的方法研究》', '曾 璇', '复旦大学集成电路与微纳电子创新学院教授、国家信息产业部十一五和2020中长期规划集成电路领域专家'),
      scheduleItem('16:00-16:30 签约与发布仪式', '', '', [
        person('', '1.OpenCL算子库战略合作'),
        person('', '2.智慧眼发布：国内首个医疗全场景一体化AI协同平台—MedClawd')
      ]),
      scheduleItem('16:30-17:15 圆桌论坛：《开放异构·算力自主：大模型时代国产OpenCL产业生态建设》', '', '', [
        person('周国庆', '阿里云智能集团湖南分公司副总经理'),
        person('赵艳梅', '长沙景嘉微电子股份有限公司高级工程师'),
        person('', 'Sophie 小米科技有限公司市场总监'),
        person('易会战', '飞腾信息技术有限公司AI软件栈负责人'),
        person('伍华林', '兆松科技（武汉）有限公司CTO'),
        person('刘 明', 'RIOS实验室生态运营总监'),
        person('李炯明', 'CSDN高级副总裁'),
        person('戴新发', '中国船舶集团有限公司第七〇九研究所首席专家')
      ], true)
    ]
  }),

  // AI+数字内容
  '0181dc429f7b4af9a1d969dd07d21323': group({
    name: 'AI+数字内容',
    theme: 'AI+数字内容',
    time: '2026年9月24日14:00-17:30',
    location: '世界计算·长沙智谷多功能会议中心三楼',
    zdOrganizer: ['2026岳麓大会组委会', '湖南省工业和信息化厅', '湖南省科学技术厅', '湖南省广播电视局'],
    organizer: ['万兴科技集团股份有限公司'],
    coOrganizer: [
      '湖南省动漫游戏协会',
      '湖南省人工智能协会',
      '湖南省服务（数字）贸易协会',
      '长沙市新媒体协会',
      '北京生数科技集团股份有限公司',
      '深圳市慧动创想科技有限公司（DataEye剧查查）'
    ],
    schedule: [
      scheduleItem('14:25-14:40 领导讲话'),
      scheduleItem('14:40-14:55 主题演讲：《AI重构创作者经济新范式》', '吴太兵', '万兴科技集团股份有限公司创始人、董事长'),
      scheduleItem('14:55-15:10 主题演讲：《从数据洞察到智能生产：AI驱动内容产业新范式》', '汪祥斌', '深圳市慧动创想科技有限公司（DataEye剧查查）创始人、CEO'),
      scheduleItem('15:10-15:25 主题演讲：《内容产业新基座：驱动内容生产、互动和消费的创新》', '骆怡航', '北京生数科技有限公司CEO'),
      scheduleItem('15:25-15:40 主题演讲：《AIGC重构内容创作商业模式，让影视产业枯木逢春》', '李志超', '长信文化传媒集团有限公司总裁助理、AI创新业务负责人'),
      scheduleItem('15:40-15:55 主题演讲：《镜头交给AI故事留给人》', '关敬蓉', '中广天择传媒股份有限公司常务副总经理'),
      scheduleItem('15:55-16:10 主题演讲：《人工智能作为“新纸笔”：重构文化产业创造力，为人性之美续杯》', '许丕文', '香港科技大学（广州）CMA计算媒体和艺术学院长聘副教授'),
      scheduleItem('16:10-16:50 圆桌论坛一：《技术破壁与本土化跨越:AI如何重塑影视出海的最后一公里》', '赵 亮', '深圳市非凡创业咨询有限公司合伙人', [
        person('林倩晖', '万兴科技集团股份有限公司副总裁'),
        person('陈 岑', '华南理工大学教授、博士生导师'),
        person('莫馨怡', '湖南东麟影视传媒有限责任公司CEO'),
        person('赵伟均', '杭州灵漫快创科技有限公司CEO'),
        person('屈阳超', '湖南西瓜创想科技有限公司CEO')
      ], true),
      scheduleItem('16:50-17:30 圆桌论坛二：《生态合力，智造未来：AI漫剧的湖南实践与全球表达》', '关敬蓉', '中广天择传媒股份有限公司常务副经理', [
        person('吴佳兵', '万兴科技集团股份有限公司副总裁'),
        person('谢 鲲', '湖南大学计算机学院教授、博士生导师'),
        person('邓佳乐', '湖南长广千博科技有限公司董事兼总经理'),
        person('陈 花', '湖南竞网数字科技集团有限公司副总裁、长沙新媒体协会秘书长'),
        person('李东旭', '湖南芒果国际文化传媒有限公司运营负责人')
      ], true)
    ]
  }),

  // AI+机器人
  'f8cf6177a2124aa8a356736916a8ceea': group({
    name: 'AI+机器人',
    theme: 'AI+机器人',
    time: '2026年9月24日14:00-17:30',
    location: '世界计算·长沙智谷“云脑”',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['中科云谷科技有限公司', '湖南省工业互联网发展研究中心'],
    coOrganizer: ['北京创新乐知网络技术有限公司（CSDN）'],
    schedule: [
      scheduleItem('14:00-14:10 领导讲话'),
      scheduleItem('14:10-14:30 主题演讲：《耐核辐射机器人关键技术》', '姜 潮', '湖南大学党委常委、副校长，教授、博士生导师'),
      scheduleItem('14:30-14:50 主题演讲：《人形机器人具身智能关键技术与发展趋势》', '卢惠民', '国防科技大学智能科学学院首席专家、教授、博士生导师'),
      scheduleItem('14:50-15:10 主题演讲：《面向鲁棒长程操控的视觉-语言-动作模型》', '苏 修', '中南大学人工智能学院教授、博士生导师，智能科学系主任'),
      scheduleItem('15:10-15:30 主题演讲：《世界模型-迈向空间智能》', '任云帆', '同济大学计算机科学与技术学院长聘副教授、博士生导师'),
      scheduleItem('15:30-15:50 主题演讲：《具身机器人关键技术与文化科技融合探索与实践》', '张 锦', '湖南师范大学信息科学与工程学院院长、教授、博士生导师'),
      scheduleItem('15:50-16:00 校企合作计划'),
      scheduleItem('16:00-16:10 生态合作计划'),
      scheduleItem('16:10-16:30 主题演讲：《面向产线共调度的工业机器人与人形机器人机群协同》', '佘玲娟', '中科云谷科技有限公司机器人事业部副总经理'),
      scheduleItem('16:30-16:50 主题演讲：《多模态大模型赋能具身智能重塑生产力》', '季 超', '安徽聆动通用机器人科技有限公司创始人兼CEO'),
      scheduleItem('16:50-17:10 主题演讲：《从“会动”到“会进化”：大模型驱动的机器人智能闭环》', '朱禹睿', '中兴通讯股份有限公司具身智能总工')
    ]
  }),

  // AI+脑机接口
  '88fe0ef4c37d422592d09a008a1de6eb': group({
    name: 'AI+脑机接口',
    theme: 'AI+脑机接口',
    time: '2026年9月24日14:00-17:00',
    location: '中电软件园总部大楼二楼多功能厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['湖南省数字经济促进会', '湖南脑机智能创新中心'],
    coOrganizer: [
      '湖南省人工智能协会',
      '湖南省网络空间安全协会',
      '湖南省传感器产业促进会',
      '湖南省科技助残促进会',
      '湖南省应急救援协会',
      '湖南省爆破行业协会',
      '湖南省水土保持学会',
      '湖南省人才集团',
      '长沙市红枫科技创新服务中心',
      '长沙中电软件园有限公司'
    ],
    schedule: [
      scheduleItem('14:00-14:15 领导讲话'),
      scheduleItem('14:15-14:20 签约仪式'),
      scheduleItem('14:20-14:30 主题演讲：《湖南脑机智能创新中心介绍》', '黄 辉', '湖南脑机接口智能科技有限公司创始人'),
      scheduleItem('14:30-14:48 主题演讲：《重大脑疾病个体化闭环脑机接口技术的研发及应用》', '王 汨', '中南大学湘雅医院临床心理科教学主任'),
      scheduleItem('14:48-15:06 主题演讲：《脑机接口生态图谱和行业趋势》', '张宇涛', '合盈脑机基金合伙人'),
      scheduleItem('15:06-15:24 主题演讲：《非侵入式BCI，解码情绪与认知，重塑大脑健康》', '祝 浩', '杭州虚之实科技有限公司营销副总经理'),
      scheduleItem('15:24-15:42 主题演讲：《脑机接口在教育科研领域的应用》', '李 欣', '博睿康技术（上海）股份有限公司市场经理'),
      scheduleItem('15:42-16:00 主题演讲：《脑机接口技术在安全管理智能化建设中的应用与实践》', '陈 翔', '华脑安全（北京）科技有限公司市场总监'),
      scheduleItem('16:00-16:18 主题演讲：《脑机接口大数据与基础模型平台》', '卞雅雯', '灵犀云医学科技（北京）有限公司首席运营官'),
      scheduleItem('16:18-17:00 圆桌论坛：《脑机接口产业发展：未来机遇、技术攻坚与商业破局》', '黄 晶', '湖南脑机接口智能科技有限公司商务总监', [
        person('刘健彪', '长沙思维解码科技有限公司总经理'),
        person('徐大勇', '康森特生物科技（长沙）有限公司董事长'),
        person('付 洁', '上海近则生物科技有限责任公司创始人'),
        person('赵康卿', '杭州迈动数康科技有限公司联合创始人'),
        person('方海军', '领头扬科技（深圳）有限公司创始人')
      ], true)
    ]
  }),

  // AI+先进制造
  '8bed5ca5c9f741b5b633af0c41ac3eaf': group({
    name: 'AI+先进制造',
    theme: 'AI+先进制造',
    time: '2026年9月24日14:00-17:30',
    location: '长沙梅溪湖金茂精选酒店三楼多功能厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['中国联合网络通信集团有限公司', '达索析统（上海）信息技术有限公司'],
    schedule: [
      scheduleItem('14:00-14:15 领导讲话'),
      scheduleItem('14:15-14:40 主题演讲：《数智融合新周期——工业AI+虚拟孪生驱动制造业全域升级》', '陈立生', '达索系统大中华区平台与云业务技术总监'),
      scheduleItem('14:40-15:05 主题演讲：《算网融合+虚拟孪生，构筑工业AI核心能力》', '范济安', '中国联通大数据首席科学家'),
      scheduleItem('15:05-15:20 主题演讲：《AI+制造，数智化新范式，新价值》', '李晓辉', '金蝶中国高端制造行业事业部副总经理'),
      scheduleItem('15:20-15:40 2026第三届智驾“封神榜”挑战赛-结果发布及颁奖', '姜 维', '国家智能网联汽车质量检验检测中心（湖南）主任，中汽院智能网联汽车检测中心（湖南）有限公司总经理'),
      scheduleItem('15:40-16:00 主题演讲：《汽车及零部件——AI+虚拟孪生助力整车与零部件协同智造》', '熊 靖', '达索系统汽车行业北区高级技术经理'),
      scheduleItem('16:00-16:20 主题演讲：《高端装备/工程机械——AI+虚拟孪生驱动智能工厂建设》', '许国强', '三一集团CIO'),
      scheduleItem('16:20-16:40 主题演讲：《新能源产业——AI+虚拟孪生赋能电池智造》', '王 煜', '达索系统电池与新能源行业技术顾问'),
      scheduleItem('16:40-17:30 圆桌论坛：《算力筑基、技术赋能，湖南智能制造产业生态协同升级之路》', '周 腾', '达索系统大中华区战略客户高级销售总监', [
        person('范济安', '中国联通大数据首席科学家'),
        person('许国强', '三一集团CIO'),
        person('陈立生', '达索系统大中华区平台与云业务技术总监')
      ], true)
    ]
  }),

  // AI+创新产业
  'd96d77f1e23f4f619620295f7bae210c': group({
    name: 'AI+创新产业',
    theme: 'AI+创新产业',
    time: '2026年9月24日14:00-17:30',
    location: '长沙梅溪湖金茂精选酒店三楼大宴会厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['湖湘汇'],
    coOrganizer: ['长江商学院湖南校友企业家'],
    schedule: [
      scheduleItem('14:00-14:15 领导讲话'),
      scheduleItem('14:15-14:45 主题演讲：《AI时代下智能制造的底层逻辑》', '朱兴明', '深圳市汇川技术股份有限公司董事长兼总裁'),
      scheduleItem('14:45-15:15 主题演讲：《打造智能体生态平台赋能AI产业发展》', '周超男', '润泽智算科技集团股份有限公司董事长'),
      scheduleItem('15:15-16:30 圆桌论坛一：《共创AI未来产业新“湘”潮》', '姚劲波', '北京五八信息技术有限公司董事长兼CEO', [
        person('周群飞', '蓝思科技股份有限公司董事长'),
        person('李新宇', '拓维信息系统股份有限公司董事长'),
        person('徐少春', '金蝶国际软件集团有限公司董事会主席兼CEO'),
        person('于 浩', '联想控股股份有限公司CEO'),
        person('赵德力', '广东汇天航空航天科技有限公司创始人'),
        person('姚 颂', '正行创新（北京）科技有限公司创始人兼CEO'),
        person('林恒毅', '广州宸境科技有限公司联合创始人')
      ], true),
      scheduleItem('16:30-17:30 圆桌论坛二：《全球AI投资新浪潮与湖南新机遇》', '倪正东', '清科集团董事长', [
        person('龚虹嘉', '嘉道资本董事长'),
        person('刘 昼', '深圳市达晨财智创业投资管理有限公司董事长'),
        person('傅哲宽', '启赋私募基金管理有限公司董事长'),
        person('陈湘宇', '深圳市创梦天地科技有限公司创始人兼CEO'),
        person('李罗丹', '讯兔科技（上海）有限公司创始人兼CEO'),
        person('时云志', '深圳市不停科技有限公司联合创始人兼首席运营官')
      ], true)
    ]
  }),

  // AI+新质未来
  '9433972333114840ad4346f4b8ec8cf6': group({
    name: 'AI+新质未来',
    theme: 'AI+新质未来',
    time: '2026年9月24日14:00-17:00',
    location: '湘江基金小镇13栋五楼路演厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: [
      '湖南财信金融控股集团有限公司',
      '深圳市达晨财智创业投资管理有限公司',
      '湖南湘江新区国有资本投资有限公司'
    ],
    coOrganizer: ['湘江基金小镇'],
    schedule: [
      scheduleItem('14:05-14:15 领导讲话'),
      scheduleItem('14:15-14:45 圆桌论坛一：《AI重构未来产业新范式》', '傅忠红', '深圳市达晨财智创业投资管理有限公司合伙人、副总裁', [
        person('惠成峰', '上海方广投资管理有限公司合伙人'),
        person('华 桦', '北京华控投资顾问有限公司合伙人、董事长'),
        person('周 星', '深圳市创东方投资有限公司合伙人'),
        person('胡佑周', '深圳市东方富海投资管理股份有限公司合伙人'),
        person('刘敏杰', '湖南高新产业投资集团有限公司创业投资分公司副总经理')
      ], true),
      scheduleItem('14:45-15:15 圆桌论坛二：《AI新周期下的产业投资与价值发现》', '郑薇薇', '上海智盈股权投资管理有限公司合伙人、轮值CEO', [
        person('黄 薇', '深圳华业天成投资有限公司合伙人'),
        person('篮志扬', '和利创业投资管理（苏州）有限公司合伙人'),
        person('王鹏飞', '奇安（北京）投资管理有限公司创始合伙人'),
        person('赵 奕', '赛富亚洲投资基金管理公司（SAIF Partners）合伙人')
      ], true),
      scheduleItem('15:15-16:30 项目路演', '', '', [
        person('', '科技企业代表：'),
        person('庄子扬', '深圳生境科技有限公司创始人'),
        person('许小珂', '湖南北云科技有限公司董秘、总经理助理'),
        person('周 琛', '湖南三岳数维科技有限公司创始人、CEO'),
        person('张 磊', '中科慧思具身智能（湖南）有限公司董事会秘书'),
        person('崔向阳', '湖南迈曦软件有限责任公司董事长、总经理')
      ]),
      scheduleItem('16:30-17:00 自由交流')
    ]
  }),

  // AI+未来城市
  'ac112ff0f9ae42229022a95e60128196': group({
    name: 'AI+未来城市',
    theme: 'AI+未来城市',
    time: '2026年9月24日14:00-17:00',
    location: '长沙步步高福朋喜来登酒店五楼多功能1厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['北京大学政府管理学院', '湖南大学公共管理学院'],
    coOrganizer: ['北京大学城市治理研究院', '住建部中国城乡建设与社区治理研究院'],
    schedule: [
      scheduleItem('14:05-14:20 领导讲话'),
      scheduleItem('14:20-14:40 主题演讲：《可计算的未来城市——面向新质生产力的土地要素统一市场设计》', '沈体雁', '北京大学政府管理学院教授'),
      scheduleItem('14:40-15:00 主题演讲：《智能社会标准化治理与城市治理标准化》', '汝 鹏', '清华大学公共管理学院教授'),
      scheduleItem('15:00-15:20 主题演讲：《城市国土空间数智治理》', '项广鑫', '湖南省国土资源规划院科技发展部副部长'),
      scheduleItem('15:20-15:40 主题演讲：《数字技术赋能城市公共服务：机理与途径》', '谭海波', '湖南大学公共管理学院院长'),
      scheduleItem('15:40-16:00 主题演讲：《未来城市社区运营：以效率与效益支撑城市的每一天》', '傅胜龙', '大汉控股集团董事长'),
      scheduleItem('16:20-17:00 圆桌论坛：《以“规划管控数智化、建造运营智能化、社区治理人本化”三位一体的未来城市发展格局为核心，重点讨论数据要素与人工智能驱动的未来城市化路径，以及人与城市和谐共生的治理变革》', '谷 浩', '湖南大学公共管理学院副教授', [
        person('彭小宝', '中国科学技术大学公共管理学院副教授'),
        person('蔡长昆', '华中科技大学公共管理学院副教授'),
        person('付 磊', '湖南未来智慧城市运营管理有限公司总经理'),
        person('曹正堂', '湖南悦匠数字科技有限公司总经理'),
        person('欧 莉', '湖南省数据局数据要素处副处长')
      ], true)
    ]
  }),

  // AI+科研创新
  '9fa697e16f6c481585b9e7579c343945': group({
    name: 'AI+科研创新',
    theme: 'AI+科研创新',
    time: '2026年9月24日14:00-17:30',
    location: '长沙步步高福朋喜来登酒店三楼大宴会厅',
    zdOrganizer: ['2026岳麓大会组委会'],
    organizer: ['华为技术有限公司'],
    coOrganizer: ['中南大学', '湖南大学'],
    schedule: [
      scheduleItem('14:00-14:10 领导讲话'),
      scheduleItem('14:10-14:50 主题演讲：《AI赋能地下矿山特种车辆安全控制：主动避撞决策与虚实融合仿真》', '桂 瑰', '中南大学教授'),
      scheduleItem('14:50-15:30 主题演讲：《科学具身多智能体》', '王智慧', '深圳河套学院科学与工程智能中心教授'),
      scheduleItem('15:30-16:10 主题演讲：《广州实验室抗体智造系统AI4S L4实践》', '郭 东', '广州实验室中国数字肺工程技术中心AI高级工程师'),
      scheduleItem('16:10-16:50 主题演讲：《高性能、易用、智能化：助力科学与工程计算创新的AI4S基础设施》', '王 龙', '华为超智协同实验室主任、计算机系统优化首席专家'),
      scheduleItem('16:50-17:30 圆桌论坛：《AI加速科研创新》', '胡其高', '湖南省人工智能协会秘书长', [
        person('郭 东', '广州实验室中国数字肺工程技术中心AI高级工程师'),
        person('廖 鑫', '湖南大学教授、网络空间安全学院副院长、国家高层次青年拔尖人才'),
        person('王 龙', '华为超智协同实验室主任、计算机系统优化首席专家')
      ], true)
    ]
  }),

  // AI+创新创业展只有总日程页信息，手册没有单独的论坛议程页。
  'eaff8f5c68f6402ea70a3ac9525e692f': group({
    name: 'AI+创新创业展',
    theme: 'AI+创新创业展',
    time: '2026年9月24日09:30-17:00',
    location: '世界计算·长沙智谷“云脑”',
    schedule: [
      scheduleItem('09:30-17:00 AI+创新创业展')
    ]
  })
}

const getDefaultState = function () {
  return {
    group: {},
    groupList,
    groupArray: []
  }
}

const state = getDefaultState()

const mutations = {
  SET_GROUP(state, group) {
    state.group = group
  },
  SET_GROUPARRAY(state, list) {
    state.groupArray = list
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
